export default __webpack_public_path__ + "static/media/ic_helmet.52d5b818.svg";